var module = angular.module('octopusApp.infrastructure');

module.filter('htmlEscape', function() {
    return function (input, format) {
        return _.escape(input);
}});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/htmlEscape.js
// module id = 5642537118014068
// module chunks = 1